import { useContext, useEffect, useState } from "react"
import { AccountContext } from "../contexts/AccountContexts"
import { loadingActive } from "./Background"
import { FaBan, FaRegHandPaper } from "react-icons/fa";
import { BsEmojiAngry } from "react-icons/bs"
import { PiRobot } from "react-icons/pi"
import { IoIosBug } from "react-icons/io"
import { RiAdvertisementLine, RiMoneyEuroCircleLine } from "react-icons/ri"
import { MdAttachMoney } from "react-icons/md"
import { TbLogin2, TbNumber11Small } from "react-icons/tb"
import { GrCircleQuestion } from "react-icons/gr"
import { AiOutlinePlus } from "react-icons/ai"
import { ContentContext, useError } from "../contexts/ContentContext"
import { setImageUrl } from "../utils"
import { requestAssignDev, requestFastActionExcuses, requestPutTicketOnHold, requestReopenTicket, requestSetRetainAttachments, requestSubmitCompleteTicket } from "../requests/ticket_requests"
import { useTranslation } from "react-i18next";
import { useConfirm } from "../contexts/ModalContexts";
import { LuThumbsUp, LuTicket } from "react-icons/lu";
import { BiCategory } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { DontShowAgainComponent } from "./ModalComponents";
import { requestChat } from "../requests/chat_requests";



export const TicketAttrRow = ({ attrName, attrContent }) => {

    return (
        <div className="flex flex-wrap items-center">
            <h4 className="min-w-36 max-w-36 text-wrap">{attrName}</h4>
            <h4 className="font-semibold truncate">{attrContent}</h4>
        </div>
    )
}

export const TicketAttrEditRow = ({ attrName, selectedAttr, placeHolder, options, setNew, collection }) => {
    const { t } = useTranslation('common')
    const [content, setContent] = useState(selectedAttr)

    useEffect(() => {
        setNew(content)
    }, [content])

    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 100);

        return () => {
            clearTimeout(timer);
        }
    }, [])

    return (
        <div className={`flex flex-wrap items-center
        transition-all duration-500 ease-in-out transform
            ${isVisible ? 'opacity-100  translate-x-0 ' : 'opacity-10 ltr:translate-x-5 rtl:-translate-x-5'}
        `}>
            <h4 className="min-w-36 font-bold">{attrName}</h4>
            <select required className="select select-bordered select-sm bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300" value={content || ""} onChange={(e) => { setContent(e.target.value); }}>
                <option disabled value="">{placeHolder}</option>
                {
                    !options.includes(selectedAttr) &&
                    <option className="ltr:italic font-bold" value={selectedAttr}>{t(collection[selectedAttr].title)}</option>
                }
                {options.map((option, index) => (
                    <option key={index}
                        className={`${option === selectedAttr && "ltr:italic font-bold"}`} value={option}>{t(collection[option].title)}</option>
                ))}
            </select>
        </div>
    )
}

export const SideActionButton = ({ content, callback, title = "", disabled = false }) => {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 100);

        return () => {
            clearTimeout(timer);
        }
    }, [])

    return (
        <button className={`btn btn-square btn-sm h-7 w-8 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300 hover:bg-primary text-xl hover:text-white
            border-2 border-primary/50 hover:border-primary/70 dark:hover:bg-blue-600 dark:border-gray-600
            transition-all duration-300 ease-in-out transform
                disabled:border-gray-200 dark:disabled:border-gray-700
            ${isVisible ? 'opacity-100  translate-y-0 ' : 'opacity-10 -translate-y-5'}
            `}
            title={title}
            disabled={disabled}
            onClick={callback}
        >{content}</button>

    )
}


export const BanUserButton = ({ user, ticket, getData, title = "", disabled = false }) => {
    const { t } = useTranslation('edit')
    const { openErrorModal } = useContext(ContentContext)
    const getConfirmation = useConfirm()

    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(true);
        }, 100);

        return () => {
            clearTimeout(timer);
        }
    }, [])


    const handleClick = () => {
        document.getElementById("ticket-ban-modal").showModal()
    }

    return (
        <button className={`btn btn-square btn-sm h-7 w-8 bg-white dark:bg-gray-700 
            ${user.banned ? "hover:bg-green-600 dark:hover:bg-green-700 text-green-600 dark:text-green-500 border-green-600/50 hover:border-green-500 dark:hover:border-green-600" : "hover:bg-red-600 dark:hover:bg-red-700 text-red-600 dark:text-red-500 border-red-600/50 hover:border-red-500 dark:hover:border-red-600"}
            text-xl  hover:text-white border-2 
            transition-all duration-500 ease-in-out transform
                disabled:border-gray-200 dark:disabled:border-gray-700
            ${isVisible ? 'opacity-100  translate-y-0 ' : 'opacity-10 -translate-y-5'}
            `}
            title={title}
            disabled={disabled}
            onClick={handleClick}
        >{user.banned ? <LuThumbsUp /> : <FaBan />}</button>

    )
}


export const TicketAssignModal = ({ socket, currentCategory, setTicketInformation, ticketId, ticketServer, assignedTo, chatId }) => {
    const { t } = useTranslation(['edit', 'common'])

    const { user, devs, language } = useContext(AccountContext)
    const { categories, openErrorModal } = useContext(ContentContext)
    const [selectedDev, setSelectedDev] = useState(null)
    const [selectedCategory, setSelectedCategory] = useState(currentCategory)
    const [random, setRandom] = useState(true)

    const handleClick = (dev, isRandom) => {
        if (isRandom) {
            setRandom(true)
            setSelectedDev(null)
        }
        else if (selectedDev && selectedDev.id === dev.id) {
            setSelectedDev(null)
            setRandom(false)
        }
        else {
            setSelectedDev(dev)
            setRandom(false)
        }
    }

    useEffect(() => {
        setSelectedCategory(currentCategory)
    }, [currentCategory])


    const handleSubmit = () => {
        loadingActive(true)
        requestAssignDev({ selectedDevId: selectedDev ? selectedDev.id : null, ticketId: ticketId, selectedCategory: selectedCategory, server: ticketServer, chatId: chatId, random: random, prevDevId: assignedTo })
            .then((data) => {

                if (socket.disconnected) {
                    setTicketInformation({ ticketData: data.ticket })
                }
                loadingActive(false)
                setSelectedCategory(data.ticket.category)
                setSelectedDev(null);
                document.getElementById("ticket-assign-modal").close()
                onClose()
            })
            .catch((error) => {
                // loadingActive(false)
                openErrorModal(error)
                onClose()
            })
    }

    const onClose = () => {
        setRandom(true)
        setSelectedDev(null)
        setSelectedCategory(currentCategory)
    }

    const submitCondition = random || selectedDev

    return (
        <>

            <dialog id="ticket-assign-modal" className="modal">
                <div className="modal-box flex flex-col gap-3 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300">
                    <h3 className="font-bold text-lg w-full text-center">{t('Ticket Assign')}</h3>

                    <div className="flex flex-col items-center">

                        <p className="py-4 font-semibold">{t('Choose the category')}</p>
                        <select required className="select select-bordered select-sm max-w-max bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300"
                            value={selectedCategory || ""}
                            onChange={(e) => { setSelectedCategory(e.target.value); }}
                        >
                            <option disabled value="">{t('Select category')}</option>
                            {Object.values(categories).map((option, index) => (
                                <option key={index} value={option.id}>{option?.locales?.[language] ? option?.locales?.[language] : t(option.title, { 'ns': "common" })}</option>
                            ))}
                        </select>
                    </div>
                    {
                        user.rank !== "dev" &&
                        <>

                            <div className="pb-2 pt-4 flex w-full justify-center font-semibold">

                                <h3>{t('Choose an employee')}</h3>
                            </div>

                            <div className="flex justify-center flex-wrap gap-3">
                                <button className={`group flex flex-col items-center p-2 gap-2 border-2 hover:bg-primary/5 rounded-2xl min-w-24  text-sm  select-none
                                    ${random ? "border-primary hover:border-primary dark:border-blue-600 dark:hover:border-blue-600 bg-primary/5" : "border-white dark:border-gray-600 hover:border-primary/50 dark:hover:border-primary"}
                                    `}
                                    onClick={() => { handleClick(selectedDev, true) }}
                                >
                                    <div className="chat-image avatar w-full justify-center">
                                        <div className="w-14 rounded-full">
                                            <div className="w-14 h-14 rounded-full bg-yellow-500 border-2 border-primary  flex items-center justify-center text-black text-2xl select-none">
                                                ?
                                            </div>
                                        </div>
                                    </div>
                                    <h1 className="font-bold">{t('Auto')}</h1>
                                </button>

                                {
                                    Object.values(devs).map((dev, index) =>

                                        (dev.categories?.includes(selectedCategory) && dev.servers?.includes(ticketServer) && assignedTo !== dev.id) &&
                                        <button key={index} className={`group flex flex-col items-center p-2 gap-2 border-2   hover:bg-primary/5 rounded-2xl min-w-24  text-sm  select-none
                                    ${selectedDev && selectedDev.id === dev.id ? "border-primary hover:border-primary dark:border-blue-600 dark:hover:border-blue-600 bg-primary/5" : "border-white dark:border-gray-600 hover:border-primary/50 dark:hover:border-primary"}
                                    `}
                                            onClick={() => { handleClick(dev) }}
                                        >
                                            <div className="chat-image avatar w-full justify-center">
                                                <div className="w-14 rounded-full">
                                                    {

                                                        dev.avatar.length < 3 ?
                                                            <div className="w-14 h-14 rounded-full bg-fuchsia-700 flex items-center justify-center text-white text-lg select-none">
                                                                {/* {dev.email[0].toUpperCase()} */}
                                                                {"GM"}
                                                            </div>
                                                            :
                                                            <img
                                                                alt="Tailwind CSS chat bubble component"
                                                                src={setImageUrl(dev.avatar)} />

                                                    }
                                                </div>
                                            </div>
                                            <h1 className="font-semibold">{dev.name}</h1>
                                        </button>
                                    )
                                }

                            </div>
                        </>
                    }

                    <div className="flex flex-col items-center w-full mt-4 gap-3">
                        {
                            currentCategory !== selectedCategory &&
                            <h3 className="text-red-600 dark:text-red-500">{t('The category of the ticket will be changed.')}</h3>
                        }
                        <button
                            disabled={!submitCondition}
                            onClick={handleSubmit}
                            className="btn bg-primary hover:bg-primary/70 border-none text-white">{t('Submit')}</button>
                    </div>
                </div>
                <form method="dialog" className="modal-backdrop">
                    <button onClick={onClose}>close</button>
                </form>
            </dialog>
        </>

    )
}


export const TicketFastCompleteModal = ({ chat, user, ticketInfo, setTicketInformation }) => {
    const { t } = useTranslation('edit')
    const { openErrorModal } = useContext(ContentContext)
    const [selectedAction, setSelectedAction] = useState(null)
    const [fastActionExcuses, setFastActionExcuses] = useState(null)
    const [excuse, setExcuse] = useState("")
    const [otherExcuse, setOtherExcuse] = useState("")
    const [showExcuseSelect, setShowExcuseSelect] = useState(false)
    const [isOther, setIsOther] = useState(false);
    const [completeAction, setCompleteAction] = useState(false)


    const autoRedirect = false
    const navigator = useNavigate()

    useEffect(() => {
        if (chat.length > 0) {

            let removedNotificationsChat = chat.filter((message) => message.type === "message")
            let lastMessage = removedNotificationsChat[removedNotificationsChat.length - 1]
            if (lastMessage.user_class === "user" || (lastMessage.user_class === "dev" && lastMessage.sender_id !== user.id)) {
                setShowExcuseSelect(true)
            }
            else {
                setShowExcuseSelect(false)
            }
        }

    }, [chat, user])



    useEffect(() => {

        if (user.class === "user") {
            return
        }

        requestFastActionExcuses({})
            .then((data) => {
                setFastActionExcuses(data.fast_action_excuses)
            })
            .catch((error) => {
                console.error(error.status, error.message)
                openErrorModal(error)
            })

    }, [])


    const handleClick = (action) => {
        if (selectedAction && selectedAction === action) {

            setSelectedAction(null)
        }
        else {

            setSelectedAction(action)
        }
        setExcuse("")
        setOtherExcuse("")
        setIsOther(false)
    }

    useEffect(() => {
        if (completeAction && autoRedirect) {
            setTimeout(() => {
                navigator("/admin/ticket")
            }, 100)
            setCompleteAction(false)
        }
    }, [completeAction])

    const handleSubmit = () => {

        loadingActive(true)

        requestSubmitCompleteTicket({ ticketInfo: ticketInfo, action: selectedAction, excuse: excuse === t("Other") && otherExcuse !== "" ? otherExcuse : excuse, isUnAnswered: showExcuseSelect })
            .then((data) => {
                setTicketInformation({ ticketData: data.ticket_data })
                document.getElementById("ticket-fast-complete-modal").close()
                loadingActive(false)
                setSelectedAction(null)
                setCompleteAction(true)
            })
            .catch((error) => {
                console.error(error.status, error.message)
                openErrorModal(error)
            })
    }

    const handleExcuseSelect = (e) => {
        e.preventDefault()
        if (excuse === t("Other") && e.target.value !== t("Other")) {
            setIsOther(false)
            setOtherExcuse("")
        }

        setExcuse(e.target.value)
    }


    const onClose = () => {
        setSelectedAction(null)
        setExcuse("")
        setOtherExcuse("")
        setIsOther(null)
    }

    const submitCondition = selectedAction && !(showExcuseSelect && excuse === "") && !(excuse === t("Other") && otherExcuse === "")

    return (
        <>

            <dialog id="ticket-fast-complete-modal" className="modal">
                <div className="modal-box flex flex-col gap-3 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300">
                    <h3 className="font-bold text-lg w-full text-center">{t('Fast Complete Ticket')}</h3>

                    <div className="pb-2 pt-4 flex w-full justify-center font-semibold">

                        <h3>{t('Choose action')}</h3>
                    </div>

                    <div className="flex justify-center flex-wrap gap-3">

                        <button className={`group flex flex-col items-center p-2 gap-2 border-2   hover:bg-primary/5 rounded-2xl min-w-32  text-sm  select-none
                                    ${selectedAction && selectedAction === "RESOLVED" ? "border-primary hover:border-primary bg-primary/5" : "border-white hover:border-primary/50 dark:border-gray-700 dark:hover:border-primary"}
                                    `}
                            onClick={() => { handleClick("RESOLVED") }}
                        >
                            <div className="chat-image avatar w-full justify-center">
                                <div className="w-14 rounded-full">
                                    <img
                                        alt="Ticket assigned to"
                                        src={"https://img.icons8.com/?size=100&id=OxzN9JfkLDmx&format=png&color=000000"} />
                                </div>
                            </div>
                            <h1 className="font-semibold">{t('Resolve Ticket')}</h1>
                        </button>
                        <button className={`group flex flex-col items-center p-2 gap-2 border-2   hover:bg-primary/5 rounded-2xl min-w-32  text-sm  select-none
                                    ${selectedAction && selectedAction === "CLOSED" ? "border-primary hover:border-primary bg-primary/5" : "border-white hover:border-primary/50 dark:border-gray-700 dark:hover:border-primary"}
                                    `}
                            onClick={() => { handleClick("CLOSED") }}
                        >
                            <div className="chat-image avatar w-full justify-center">
                                <div className="w-14 rounded-full">
                                    <img
                                        alt="Ticket assigned to"
                                        src={"https://img.icons8.com/?size=100&id=HXsXwZnHT7jh&format=png&color=000000"} />
                                </div>
                            </div>
                            <h1 className="font-semibold">{t('Close Ticket')}</h1>
                        </button>

                    </div>

                    <div className="flex flex-col items-center w-full mt-4 gap-3">
                        {
                            selectedAction && showExcuseSelect &&
                            <>
                                <h3 className="text-gray-800 dark:text-gray-300 font-semibold">{t('Why are you closing the ticket?')}</h3>
                                <select className="select select-bordered select-md max-w-max bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300" onChange={handleExcuseSelect}>
                                    <option disabled selected={excuse === ""} >{t('Select your reason')}</option>
                                    {
                                        fastActionExcuses[selectedAction].map((excuse, index) =>
                                            <option key={index}>{excuse}</option>
                                        )
                                    }
                                    <option>{t("Other")}</option>

                                </select>
                                {excuse === t("Other") &&
                                    <input className="input input-sm input-bordered w-2/3 max-w-72 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-500 text-gray-800 dark:text-gray-300" placeholder={t("Type your reasoning here")} value={otherExcuse} onChange={(e) => setOtherExcuse(e.target.value)} />
                                }
                            </>
                        }
                        <button
                            disabled={!submitCondition}
                            onClick={handleSubmit}
                            className="btn bg-primary hover:bg-primary/70 border-none text-white">{t('Submit')}</button>
                    </div>
                </div>
                <form method="dialog" className="modal-backdrop">
                    <button onClick={onClose}>close</button>
                </form>
            </dialog>
        </>
    )
}


export const TicketReopenModal = ({ ticketInfo, setTicketInformation, messageFunction, isByReply = false }) => {
    const { t } = useTranslation('edit')
    const [lastUserClass, setLastUserClass] = useState(null)

    const handleConfirm = () => {
        requestReopenTicket({ ticketInfo: ticketInfo, lastUserClass: lastUserClass }).then((data) => {
            setTicketInformation({ ticketData: data.ticket_data })
            document.getElementById("ticket-reopen-modal").close()
            if (isByReply) {
                messageFunction()
            }
        })
    }

    useEffect(()=>{
        requestChat({ chatId: ticketInfo.chat_id, userClass: "user" }).then((data) => {
            setLastUserClass(data.chat?.reduce((acc, chat) => { 
                if (chat.user_class === "user" || chat.user_class === "dev") return chat;
                return acc;
            }, null)?.user_class)
        })
    },[ticketInfo])

    return (
        <>
            <dialog id="ticket-reopen-modal" className="modal">
                <div className="modal-box flex flex-col gap-3 items-center bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300">
                    <h3 className="font-bold text-lg w-full text-center">{t('Reopen Ticket')}</h3>

                    <div className="pb-2 pt-4 flex w-full justify-center font-semibold">

                        <h3>{t('Caution!')}</h3>
                    </div>
                    <div className="flex flex-col">

                        <div className="flex flex-col gap-2">
                            <p>{t("This ticket will be reopened and it's status will be set to:")}</p>
                            <div className="flex w-full justify-center">

                                <StatusBubble ticketStatus={isByReply ? "REPLIED" : lastUserClass === "dev" ? "REPLIED" : "WAITING DEV"} />
                            </div>
                        </div>
                        <p className="mt-4">{t('Do you still want to continue?')}</p>
                    </div>
                    <div className="flex justify-center gap-2 mt-2">
                        <button className="btn btn-md min-w-24 bg-primary hover:bg-primary/70 text-white border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500"
                            onClick={handleConfirm}
                        >{t('Yes')}</button>
                        <button className="btn btn-md min-w-24 bg-white dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-300 hover:border-gray-300 dark:hover:border-gray-500 border border-gray-300 dark:border-gray-600"
                            onClick={() => { document.getElementById("ticket-reopen-modal").close() }}
                        >{t('No')}</button>
                    </div>
                </div>
            </dialog>
        </>
    )
}


export const TicketPutOnHoldModal = ({ ticketInfo, setTicketInformation, user }) => {
    const { t } = useTranslation('edit')
    const [loading, setLoading] = useState(false)

    const handleConfirm = () => {
        setLoading(true)
        requestPutTicketOnHold({ ticketId: ticketInfo.id })
            .then((data) => {
                setTicketInformation({ ticketData: data.ticket_data })
                document.getElementById("ticket-put-on-hold-modal").close()
            })
            .catch((error) => {
                console.error(error.status, error.message)
            })
            .finally(() => {
                setLoading(false)
            })

    }

    return (
        <>
            <dialog id="ticket-put-on-hold-modal" className="modal">
                <div className="modal-box flex flex-col gap-3 items-center bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300">
                    <h3 className="font-bold text-lg w-full text-center">{t('Ticket on hold')}</h3>

                    <div className="pb-2 pt-4 flex w-full justify-center font-semibold">

                        <h3>{t('Caution!')}</h3>
                    </div>
                    <div className="flex flex-col">

                        <div className="flex flex-col gap-2">
                            <p>{t("The ticket will be put on hold until further action is applied.")}</p>
                            <div className="flex w-full justify-center">

                                <StatusBubble ticketStatus={"ON HOLD"} />
                            </div>
                        </div>
                        <p className="mt-4">{t('Do you still want to continue?')}</p>
                    </div>
                    <div className="flex justify-center gap-2 mt-2">
                        <button className="btn btn-md min-w-24 bg-primary hover:bg-primary/70 text-white border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500"
                            disabled={loading}
                            onClick={handleConfirm}
                        >{t('Yes')}</button>
                        <button className="btn btn-md min-w-24 bg-white dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-300 hover:border-gray-300 dark:hover:border-gray-500 border border-gray-300 dark:border-gray-600"
                            onClick={() => { document.getElementById("ticket-put-on-hold-modal").close() }}
                        >{t('No')}</button>
                    </div>
                </div>
                <form method="dialog" className="modal-backdrop">
                    <button onClick={() => { document.getElementById("ticket-put-on-hold-modal").close() }}>close</button>
                </form>
            </dialog>
        </>
    )
}


export const TicketSubmitAndResolveWarningModal = ({ ticketInfo, completeInProgress, callback }) => {
    const { t } = useTranslation('edit')
    const [clicked, setClicked] = useState(false)

    const [dontShowKey, setDontShowKey] = useState(String(Date.now()))

    const handleConfirm = () => {
        setClicked(true)
        callback()
    }

    useEffect(() => {
        if (completeInProgress) {
            setClicked(true)
        }
        else {
            setClicked(false)
        }
    }, [ticketInfo, completeInProgress])

    const onClose = () => {
        document.getElementById("ticket-submit-and-resolve-warning-modal").close()
        setDontShowKey(String(Date.now()))
    }

    return (
        <>
            <dialog id="ticket-submit-and-resolve-warning-modal" className="modal" >
                <div className="modal-box flex flex-col gap-3 items-center bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300">
                    <h3 className="font-bold text-lg w-full text-center">{t('Resolve Ticket')}</h3>
                    <div className="pb-2 pt-4 flex w-full justify-center font-semibold">

                        <h3>{t('Caution!')}</h3>
                    </div>
                    <div className="flex flex-col">

                        <div className="flex flex-col gap-2">
                            <p>{t("This ticket will be marked as resolved and it's status will be set to:")}</p>
                            <div className="flex w-full justify-center">

                                <StatusBubble ticketStatus={"RESOLVED"} />
                            </div>
                        </div>
                        <p className="mt-4">{t('Do you still want to continue?')}</p>
                    </div>
                    <DontShowAgainComponent id={dontShowKey} itemId={"ticket-resolve-warning-modal"} isSave={clicked} />
                    <div className="flex justify-center gap-2 mt-2">
                        <button disabled={clicked} className="btn btn-md min-w-24 bg-primary hover:bg-primary/70 text-white border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500"
                            onClick={handleConfirm}
                        >{t('Yes')}</button>
                        <button className="btn btn-md min-w-24 bg-white dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-300 hover:border-gray-300 dark:hover:border-gray-500 border border-gray-300 dark:border-gray-600"
                            onClick={onClose}
                        >{t('No')}</button>
                    </div>

                </div>
            </dialog>
        </>
    )
}


export const TicketSubmitAndCloseWarningModal = ({ ticketInfo, newMessage, callback }) => {
    const { t } = useTranslation('edit')
    const [clicked, setClicked] = useState(false)

    const handleConfirm = () => {
        setClicked(true)
        callback()
    }

    useEffect(() => {
        if (newMessage === "#FINISHED#") {
            setClicked(true)
        }
        else if (newMessage !== "") {
            setClicked(false)
        }
    }, [ticketInfo, newMessage])

    return (
        <>
            <dialog id="ticket-submit-and-close-warning-modal" className="modal" >
                <div className="modal-box flex flex-col gap-3 items-center bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300">
                    <h3 className="font-bold text-lg w-full text-center">{t('Close Ticket')}</h3>
                    <div className="pb-2 pt-4 flex w-full justify-center font-semibold">

                        <h3>{t('Caution!')}</h3>
                    </div>
                    <div className="flex flex-col">

                        <div className="flex flex-col gap-2">
                            <p>{t("This ticket will be marked as closed and it's status will be set to:")}</p>
                            <div className="flex w-full justify-center">

                                <StatusBubble ticketStatus={"CLOSED"} />
                            </div>
                        </div>
                        <p className="mt-4">{t('Do you still want to continue?')}</p>
                    </div>
                    <DontShowAgainComponent itemId={"ticket-close-warning-modal"} isSave={clicked} />
                    <div className="flex justify-center gap-2 mt-2">
                        <button disabled={clicked} className="btn btn-md min-w-24 bg-primary hover:bg-primary/70 text-white border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500"
                            onClick={handleConfirm}
                        >{t('Yes')}</button>
                        <button className="btn btn-md min-w-24 bg-white dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-300 hover:border-gray-300 dark:hover:border-gray-500 border border-gray-300 dark:border-gray-600"
                            onClick={() => { document.getElementById("ticket-submit-and-close-warning-modal").close() }}
                        >{t('No')}</button>
                    </div>

                </div>
            </dialog>
        </>
    )
}


export const TicketRetainAttachmentsModal = ({ ticketInfo, setTicketInformation }) => {
    const { t } = useTranslation('edit')
    const modalId = "ticket-retain-attachments-modal"
    const showError = useError()

    const handleConfirm = () => {

        loadingActive(true)
        requestSetRetainAttachments({ ticketId: ticketInfo.id, isRetain: !ticketInfo?.retain_attachments })
            .then((data) => {
                setTicketInformation({ticketData: data.ticket})
                onClose()
            })
            .catch((error) => {
                console.error(error.status, error.message)
                showError(error)
            })
            .finally(() => {
                loadingActive(false)
            })
    }

    const onClose = () => {
        document.getElementById(modalId).close()
    }

    return (
        <dialog id={modalId} className="modal" >
            <div className="modal-box flex flex-col gap-3 items-center bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-300">
                <h3 className="font-bold text-lg w-full text-center">{ticketInfo?.retain_attachments ? t("Remove protection") : t('Retain attachments')}</h3>
                <div className="flex flex-col">

                    <div className="flex flex-col gap-2">
                        {
                            ticketInfo?.retain_attachments
                                ?
                                <span>{t("The automatic file removal system will again be able to delete this ticket's attachments.")}</span>
                                :
                                <span>{t("The ticket attachments will be retained and prevented from being automatically deleted.")}</span>
                        }
                    </div>
                    <p className="mt-4">{t('Do you still want to continue?')}</p>
                </div>
                <div className="flex justify-center gap-2 mt-2">
                    <button className="btn btn-md min-w-24 bg-primary hover:bg-primary/70 text-white border-gray-300 dark:border-gray-600 hover:border-gray-300 dark:hover:border-gray-500"
                        onClick={handleConfirm}
                    >{t('Yes')}</button>
                    <button className="btn btn-md min-w-24 bg-white dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-300 hover:border-gray-300 dark:hover:border-gray-500 border border-gray-300 dark:border-gray-600"
                        onClick={onClose}
                    >{t('No')}</button>
                </div>

            </div>
        </dialog>
    )
}


// CRITICAL STRUCTURE
// DO NOT CHANGE WITHOUT ADVICE
export const ticketStatusConfigs = {
    "NEW TICKET": {
        status: "NEW TICKET",
        style: "bg-yellow-400 text-black"
    },
    ACTIVE: {
        status: "ACTIVE",
        style: "bg-blue-400 text-white"
    },
    "ON HOLD": {
        status: "ON HOLD",
        style: "bg-violet-500 text-white"
    },
    "REPLIED": {
        status: "REPLIED",
        style: "bg-blue-400 text-white"
    },
    "WAITING DEV": {
        status: "WAITING DEV",
        style: "bg-amber-600 text-white"
    },
    RESOLVED: {
        status: "RESOLVED",
        style: "bg-green-400 text-white"
    },
    CLOSED: {
        status: "CLOSED",
        style: "bg-red-600 text-white"
    },
}


export const ticketCategoryConfigs = {

    "Add new": {
        status: "Add new",
        style: "bg-primary text-white dark:bg-blue-600",
        icon: <AiOutlinePlus />,
    },

    "425764ad-0e03-4356-820d-24e469c8bddc": {
        status: "Ban removal request",
        style: "bg-black text-white",
        icon: <FaBan />,
    },
    "eec2c5ea-ef25-4d4b-be33-fb36bba0d44a": {
        status: "Violating the rules of the chat",
        style: "bg-orange-950 text-white",
        icon: <BsEmojiAngry />,

    },
    "66dc266c-4e3a-4258-9fc1-c9934986b27f": {
        status: "Reporting suspected cheaters or bots",
        style: "bg-sky-950 text-white",
        icon: <PiRobot />,
    },
    "4fdc5eac-9bee-4eb7-ad1b-10372172ba40": {
        status: "Report bugs",
        style: "bg-red-600 text-white",
        icon: <IoIosBug />,
    },
    "965eddaa-bef6-4194-9460-8ee17dc7b31a": {
        status: "Payment problems (fCoin)",
        style: "bg-teal-400 text-black",
        icon: <MdAttachMoney />,
    },
    "a295c9bc-85bc-4499-9540-1a8f25c29afc": {
        status: "Suggestion and complaint",
        style: "bg-purple-800 text-white",
        icon: <FaRegHandPaper size={15} />,
    },
    "c9a1a5a3-9c0e-4cf8-b602-62ed749585a5": {
        status: "Advertising and collaboration",
        style: "bg-orange-800 text-white",
        icon: <RiAdvertisementLine />,
    },
    "82722ce4-dcaf-47c6-84f6-c3bb61d83c14": {
        status: "Registration problems",
        style: "bg-blue-700 text-white",
        icon: <TbLogin2 />,
    },
    "9723daa6-fe3f-439e-bc28-23f226ef16dc": {
        status: "Other",
        style: "bg-gray-800 text-white",
        icon: <GrCircleQuestion />,
    },
    "fcb2c960-2327-4bc5-a04d-345029ec7fd7": {
        status: "Category11",
        style: "bg-red-600 text-white",
        icon: <TbNumber11Small />,
    },
    "UNK": {
        status: "UNK",
        style: "bg-primary text-white",
        icon: <BiCategory />,
    },
    "440544ef-3086-4c31-98fe-503b3984442a": {
        status: "Support System Issues",
        style: "bg-purple-800 text-white",
        icon: <LuTicket />,
    },

}


export const StatusBubble = ({ ticketStatus, squeeze = false }) => {
    const { t } = useTranslation('common')
    const statusConfig = ticketStatusConfigs[ticketStatus]

    if (!statusConfig) {
        return <></>
    }
    return (
        <div className={`${statusConfig.style} ${squeeze ? "truncate text-nowrap text-xs max-w-16 p-1" : "text-sm max-w-max p-1 px-2"} rounded-full dark:border dark:border-gray-500`}>
            <p>{t(statusConfig.status)}</p>
        </div>
    )
}





export const CategoryBubble = ({ ticketCategory, squeeze = false }) => {
    const { t } = useTranslation('common')
    const { language } = useContext(AccountContext)
    const { categories, deletedCategories } = useContext(ContentContext)

    const categoryConfig = {
        status: categories[ticketCategory] ? (categories[ticketCategory]?.locales?.[language] ? categories[ticketCategory]?.locales[language] : t(categories[ticketCategory].title)) : deletedCategories[ticketCategory] ? t(deletedCategories[ticketCategory].title) : t("UNK"),
        style: categories[ticketCategory] ? categories[ticketCategory].style : deletedCategories[ticketCategory] ? deletedCategories[ticketCategory].style : "bg-primary text-white",
        icon: ticketCategoryConfigs[ticketCategory] ? ticketCategoryConfigs[ticketCategory].icon : <BiCategory />
    }

    if (!categoryConfig) {
        return <></>
    }
    return (
        <div className={`${categoryConfig.style} ${squeeze ? "truncate text-nowrap text-xs max-w-36 p-1" : "text-sm max-w-max truncate p-1 px-2"} rounded-full dark:border dark:border-gray-500`}>
            <p>{categoryConfig.status}</p>
        </div>
    )
}


export const PriorityBubble = ({ ticketPriority }) => {
    const { t } = useTranslation('common')
    const { priorities, deletedPriorities } = useContext(ContentContext)

    const priorityConfig = {
        status: priorities[ticketPriority] ? priorities[ticketPriority].title : deletedPriorities[ticketPriority] ? deletedPriorities[ticketPriority].title : "UNK",
        style: priorities[ticketPriority] ? priorities[ticketPriority].style : deletedPriorities[ticketPriority] ? deletedPriorities[ticketPriority].style : "bg-primary text-white",
    }

    if (!priorityConfig) {
        return <></>
    }
    return (
        <div className={`${priorityConfig.style} p-1 px-2 rounded-full text-sm max-w-max dark:border dark:border-gray-500`}>
            <p>{t(priorityConfig.status)}</p>
        </div>
    )
}


export const ExpandableBubbleSidebar = ({ config }) => {
    const { t } = useTranslation('common')

    if (!config) {
        return <></>
    }
    return (
        <div className='flex center'>
            <div className={`relative group/expandable w-6 h-6 rounded-full ${config.style ? config.style : "bg-fuchsia-800 text-white"}  hover:w-36 max-w-max flex items-center px-2 transition-all duration-300`}>
                {
                    config.icon &&
                    <span className="absolute ltr:left-1 rtl:right-1 group-hover/expandable:opacity-0">
                        {config.icon}
                    </span>
                }

                {
                    config.avatar && config.avatar.length > 3 ?
                        <div className="absolute ltr:left-[1px] rtl:right-[1px] group-hover/expandable:opacity-0 chat-image avatar">
                            <div className="w-6 rounded-full">
                                <img src={setImageUrl(config.avatar)} />
                            </div>
                        </div>
                        :
                        config.email &&
                        <div className="absolute ltr:left-[3px] rtl:right-[3px] group-hover/expandable:opacity-0 ">
                            <div className="max-w-max rounded-full text-xs leading-none text-center p-0">
                                {config.class && config.class === "dev" ? "GM" : config.email[0].toUpperCase()}
                            </div>
                        </div>
                }

                <span className={`  opacity-0 group-hover/expandable:opacity-100 transition-opacity  duration-300 truncate px-1  text-xs rounded-full `}>
                    {t(config.status)}
                </span>
            </div>
        </div>
    )
}